import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './components/hoa-app';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import theme from './hoa-theme';
import './hoa-index.scss';

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
	<ThemeProvider key={"theme-key"} theme={theme}>
		<App/>
	</ThemeProvider>
);
